export const buttonTheme = {
  className: {
    default:
      "rounded py-[6px] px-3 text-sm font-normal border-none",
    standard:
      "rounded py-[6px] px-3 text-sm font-normal border-none",
    subtle:
      "rounded py-[6px] px-3 text-sm font-normal border-none",
  },
};

export const infoTheme = {
  title: {
    className: {
      default: "text-sm text-common-white font-medium",
    },
  },
  value: {
    className: {
      default: "text-sm text-common-white text-opacity-70 font-medium",
    },
  },
};
